import {
    Badge,
    Box,
    Button,
    Divider,
    List,
    ListDivider,
    ListItem,
    ListItemButton,
    ListSubheader,
    Stack, Tooltip,
    Typography
} from "@mui/joy";
import {ICON_SIZE, sidebarMenus} from "../../values/sidebarMenus";
import {appRoute} from "../../utils/routes";
import React from "react";
import FullLogo from "../FullLogo";
import {useLocation, Link} from "react-router-dom";
import {SxProps} from "@mui/joy/styles/types";
import {BellIcon, CogIcon, Library, LogOutIcon} from "lucide-react";
import {useUITheme} from "../../hooks/useUITheme";
import {useAuth} from "../../hooks/useAuth";
import Logo from "../Logo";
import {useTranslation} from "react-i18next";
import {useNotification} from "../../hooks/useNotification";

const SideBar = () => {
    const uiTheme = useUITheme()
    return <Box height={"100%"} width={"120px"} paddingY={3} gap={2}
                alignItems={"center"}
                boxSizing={"border-box"} display={{xs: "none", md: "flex"}} flexDirection={"column"}
        // display={{md: "flex", xs: "none"}}
                sx={{
                    backdropFilter: uiTheme.sideBarProps.backdropFilter,
                    border: uiTheme.sideBarProps.border,
                    backgroundColor: uiTheme.sideBarProps.backgroundColor,
                }}>
        <Logo/>

        <SideBarContent/>

    </Box>
}

export const SideBarContent = () => {
    const location = useLocation()
    const uiTheme = useUITheme()
    const {t} = useTranslation()
    const {badgeCount}=useNotification()

    return <Stack alignItems={"center"} height={"100dvh"} justifyContent={"space-between"} boxSizing={"border-box"}
                  gap={3}>

        <List sx={{gap: 1}}>
            {sidebarMenus.map((menu, index, array) =>
                <ListItem nested>
                    <Tooltip placement={"right"} size={"sm"} title={t(menu.label)} arrow>
                        <Link to={menu.route}
                              style={{textDecoration: "none", display: "flex", justifyContent: "center"}}>
                            <ListItem data-selected={location.pathname === menu.route}
                                      sx={{
                                          width: "100%",
                                          borderRadius: 15,
                                          paddingX: 1,
                                          paddingY: 1.5,
                                          justifyContent: "center",
                                          color: location.pathname === menu.route ? uiTheme.sideBarProps.selectedTextColor : uiTheme.sideBarProps.textColor,
                                      }}>
                                <Stack alignItems={"center"} gap={1}>
                                    {menu.icon}
                                    <Typography textAlign={"center"} level={"body-xs"} sx={{color: "inherit"}}>
                                        {t(menu.label)}
                                    </Typography>
                                </Stack>

                            </ListItem>
                        </Link>
                    </Tooltip>
                </ListItem>)}

        </List>

        <Stack>
            <Tooltip placement={"right"} size={"lg"} title={t("notificationSidebarLabel")}>
                <Link to={appRoute("notifications")} style={{textDecoration: "none"}}>
                    <ListItem data-selected={location.pathname === appRoute("notifications")}
                              sx={{
                                  width: "100%",
                                  borderRadius: 15,
                                  paddingX: 2,
                                  paddingY: 1.5,
                                  justifyContent: "center",
                              }}>
                        <Stack alignItems={"center"} gap={1}>
                            <Badge badgeContent={badgeCount}>
                                <BellIcon style={{fontSize: 24}}/>
                            </Badge>
                        </Stack>

                    </ListItem>
                </Link>
            </Tooltip>

            <Tooltip placement={"right"} size={"lg"} title={t("settingsSidebarLabel")}>
                <Link to={appRoute("settings")} style={{textDecoration: "none"}}>
                    <ListItem data-selected={location.pathname === appRoute("settings")}
                              sx={{
                                  width: "100%",
                                  borderRadius: 15,
                                  paddingX: 2,
                                  paddingY: 1.5,
                                  justifyContent: "center",
                                  color: location.pathname === appRoute("settings") ? uiTheme.sideBarProps.selectedTextColor : uiTheme.sideBarProps.textColor,
                              }}>
                        <Stack alignItems={"center"} gap={1}>
                            <CogIcon style={{fontSize: 24}}/>
                        </Stack>

                    </ListItem>
                </Link>
            </Tooltip>


        </Stack>


    </Stack>

}


export default SideBar